




const breakpoints = {
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    xxl: 1400
}


function getBreakpoint(size) {
    if ( !breakpoints[size] ) throw(`Breakpoint "${size}" not found`);

    return breakpoints[size];
}


export function breakpointDown (size) {
    return window.outerWidth <= getBreakpoint(size);
};

export function breakpointUp (size) {
    return window.outerWidth > getBreakpoint(size);
};
